export { default, type ServiceHeaderSectionProps } from './ServiceHeaderSection';
